import { Route, Routes } from "react-router-dom";
import LoginPage from "../../app/auth/login";
import ProfilePage from "../../app/auth/profile";
import RegisterPage from "../../app/auth/register";
import ChangePasswordPage from "../../app/auth/change-password";
import ProfileEditPage from "../../app/auth/profile/edit";
import LogoutPage from "../../app/auth/logout";
import { AdminMiddleware } from "../../components/middleware/AdminMiddleware.tsx";
import { PublicMiddleware } from "../../components/middleware/PublicMiddleware.tsx";
import { IsValidatedMiddleware } from "../../components/middleware/IsValidatedMiddleware.tsx";
import { ProtectedMiddleware } from "../../components/middleware/ProtectedMiddleware.tsx";

export default function AuthRoutes() {
  return (
    <Routes>
      <Route
        path="/login"
        element={
          <PublicMiddleware>
            <LoginPage />
          </PublicMiddleware>
        }
      />
      <Route
        path="/logout"
        element={
          <ProtectedMiddleware>
            <LogoutPage />
          </ProtectedMiddleware>
        }
      />
      <Route
        path="/profile"
        element={
          <ProtectedMiddleware>
            <IsValidatedMiddleware>
              <ProfilePage />
            </IsValidatedMiddleware>
          </ProtectedMiddleware>
        }
      />
      <Route
        path="/profile/edit"
        element={
          <ProtectedMiddleware>
            <IsValidatedMiddleware>
              <ProfileEditPage />
            </IsValidatedMiddleware>
          </ProtectedMiddleware>
        }
      />
      <Route
        path="/register"
        element={
          <AdminMiddleware>
            <IsValidatedMiddleware>
              <RegisterPage />
            </IsValidatedMiddleware>
          </AdminMiddleware>
        }
      />
      <Route
        path="/change-password"
        element={
          <ProtectedMiddleware>
            <ChangePasswordPage />
          </ProtectedMiddleware>
        }
      />
    </Routes>
  );
}
